import { PureComponent } from 'react';

export default class extends PureComponent {
  render() {
    let { value } = this.props;
    let v = value instanceof Function ? value(document.title) : value;
    if (v && document.title !== v) {
      document.title = v;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Title.js